module.exports = __webpack_public_path__ + "public/img/daichuli.af92fb75.png";